import { useContext } from 'react';
import NotificationsContext from '../notifications/NotificationsContext';

const useNotifications = () => useContext(NotificationsContext);

export default useNotifications;